/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AppointmentRequest } from '../models/AppointmentRequest';
import type { BaseErrorResponse } from '../models/BaseErrorResponse';
import type { BaseWithMetadataRequest } from '../models/BaseWithMetadataRequest';
import type { CheckInCustomerRequest } from '../models/CheckInCustomerRequest';
import type { CheckOutDetailsRequest } from '../models/CheckOutDetailsRequest';
import type { CompanyAddress } from '../models/CompanyAddress';
import type { CreateCompanyRequest } from '../models/CreateCompanyRequest';
import type { CreateContractRequest } from '../models/CreateContractRequest';
import type { CreateCustomerCompanyRelation } from '../models/CreateCustomerCompanyRelation';
import type { CreateCustomerRequest } from '../models/CreateCustomerRequest';
import type { CreateInventoryVehicleRequest } from '../models/CreateInventoryVehicleRequest';
import type { CreateJobResponse } from '../models/CreateJobResponse';
import type { CreateMultiplyRepairOrderJobs } from '../models/CreateMultiplyRepairOrderJobs';
import type { CreatePartsOrderRequest } from '../models/CreatePartsOrderRequest';
import type { CreateSalesOrderRequest } from '../models/CreateSalesOrderRequest';
import type { CreateVehicleActionsRequest } from '../models/CreateVehicleActionsRequest';
import type { CreateVehicleRelationRequest } from '../models/CreateVehicleRelationRequest';
import type { CreateVehicleRequest } from '../models/CreateVehicleRequest';
import type { CustomerAddressesV3 } from '../models/CustomerAddressesV3';
import type { Discount } from '../models/Discount';
import type { FeeRequest } from '../models/FeeRequest';
import type { FeeResponse } from '../models/FeeResponse';
import type { FindRepairOrdersResponse } from '../models/FindRepairOrdersResponse';
import type { FindSpecificVehicleResponse } from '../models/FindSpecificVehicleResponse';
import type { GetCustomerResponse } from '../models/GetCustomerResponse';
import type { GetServiceAdvisorsResponse } from '../models/GetServiceAdvisorsResponse';
import type { InventoryVehicleStatus } from '../models/InventoryVehicleStatus';
import type { InventoryVehicleType } from '../models/InventoryVehicleType';
import type { ItemRequest } from '../models/ItemRequest';
import type { ItemResponse } from '../models/ItemResponse';
import type { ItemUpdateRequest } from '../models/ItemUpdateRequest';
import type { Job } from '../models/Job';
import type { LaborRequest } from '../models/LaborRequest';
import type { LaborResponse } from '../models/LaborResponse';
import type { MenuRequest } from '../models/MenuRequest';
import type { MenuResponse } from '../models/MenuResponse';
import type { MultiplyRepairOrderJobsResponse } from '../models/MultiplyRepairOrderJobsResponse';
import type { NoteRequest } from '../models/NoteRequest';
import type { NoteResponse } from '../models/NoteResponse';
import type { PartResponse } from '../models/PartResponse';
import type { PlanningRequest } from '../models/PlanningRequest';
import type { reateRepairOrderRequest } from '../models/reateRepairOrderRequest';
import type { RepairOrder } from '../models/RepairOrder';
import type { RepairOrderJob } from '../models/RepairOrderJob';
import type { RepairOrderPartRequest } from '../models/RepairOrderPartRequest';
import type { UpdateCustomerAddressesRequest } from '../models/UpdateCustomerAddressesRequest';
import type { UpdateCustomerCommunicationRequest } from '../models/UpdateCustomerCommunicationRequest';
import type { UpdateCustomerDetailsRequest } from '../models/UpdateCustomerDetailsRequest';
import type { UpdateCustomerIdentityRequest } from '../models/UpdateCustomerIdentityRequest';
import type { UpdateCustomerNamesRequest } from '../models/UpdateCustomerNamesRequest';
import type { UpdateCustomerPersonalDetailsRequest } from '../models/UpdateCustomerPersonalDetailsRequest';
import type { UpdateCustomerPrivacyRequest } from '../models/UpdateCustomerPrivacyRequest';
import type { UpdateIdentificationVehicleRequest } from '../models/UpdateIdentificationVehicleRequest';
import type { UpdateInspectionsVehicleRequest } from '../models/UpdateInspectionsVehicleRequest';
import type { UpdateInventoryVehicleInventoryDatesRequest } from '../models/UpdateInventoryVehicleInventoryDatesRequest';
import type { UpdateInventoryVehiclePricesRequest } from '../models/UpdateInventoryVehiclePricesRequest';
import type { UpdateMileageVehicleRequest } from '../models/UpdateMileageVehicleRequest';
import type { UpdateOdometerReadingVehicleRequest } from '../models/UpdateOdometerReadingVehicleRequest';
import type { UpdateRepairOrderDetailsRequest } from '../models/UpdateRepairOrderDetailsRequest';
import type { UpdateServiceCustomerAddressRequest } from '../models/UpdateServiceCustomerAddressRequest';
import type { UpdateServiceCustomerNameRequest } from '../models/UpdateServiceCustomerNameRequest';
import type { UpdateServiceDataVehicleRequest } from '../models/UpdateServiceDataVehicleRequest';
import type { UpdateVehicleBaseDetailsRequest } from '../models/UpdateVehicleBaseDetailsRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CdkService {

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkSalesAvailableBranches(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Sales/AvailableBranches',
    });
  }

  /**
   * @param branchId 
   * @param freeTextSearch 
   * @param givenName 
   * @param familyName 
   * @param email 
   * @param phone 
   * @param postalCode 
   * @param socialSecurityId 
   * @param page 
   * @param pageSize 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkSalesCustomerSearch(
branchId: number,
freeTextSearch?: string,
givenName?: string,
familyName?: string,
email?: string,
phone?: string,
postalCode?: string,
socialSecurityId?: string,
page: number = 1,
pageSize: number = 50,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Sales/{branchId}/Customer/Search',
      path: {
        'branchId': branchId,
      },
      query: {
        'freeTextSearch': freeTextSearch,
        'givenName': givenName,
        'familyName': familyName,
        'email': email,
        'phone': phone,
        'postalCode': postalCode,
        'socialSecurityId': socialSecurityId,
        'page': page,
        'pageSize': pageSize,
      },
    });
  }

  /**
   * @param branchId 
   * @param customerId 
   * @returns GetCustomerResponse Success
   * @throws ApiError
   */
  public static getCdkSalesCustomer(
branchId: number,
customerId: string,
): CancelablePromise<GetCustomerResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Sales/{branchId}/Customer/{customerId}',
      path: {
        'branchId': branchId,
        'customerId': customerId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param branchId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkSalesCustomerCreate(
branchId: number,
requestBody?: CreateCustomerRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Sales/{branchId}/Customer/Create',
      path: {
        'branchId': branchId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param customerId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkSalesCustomerUpdateNames(
branchId: number,
customerId: string,
requestBody?: UpdateCustomerNamesRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Sales/{branchId}/Customer/{customerId}/UpdateNames',
      path: {
        'branchId': branchId,
        'customerId': customerId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param customerId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkSalesCustomerUpdatePersonalDetails(
branchId: number,
customerId: string,
requestBody?: UpdateCustomerPersonalDetailsRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Sales/{branchId}/Customer/{customerId}/UpdatePersonalDetails',
      path: {
        'branchId': branchId,
        'customerId': customerId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param customerId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkSalesCustomerUpdateIdentity(
branchId: number,
customerId: string,
requestBody?: UpdateCustomerIdentityRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Sales/{branchId}/Customer/{customerId}/UpdateIdentity',
      path: {
        'branchId': branchId,
        'customerId': customerId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param customerId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkSalesCustomerUpdateAddresses(
branchId: number,
customerId: string,
requestBody?: UpdateCustomerAddressesRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Sales/{branchId}/Customer/{customerId}/UpdateAddresses',
      path: {
        'branchId': branchId,
        'customerId': customerId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param customerId 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkSalesCustomerPrivacy(
branchId: number,
customerId: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Sales/{branchId}/Customer/{customerId}/Privacy',
      path: {
        'branchId': branchId,
        'customerId': customerId,
      },
    });
  }

  /**
   * @param branchId 
   * @param customerId 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkSalesCustomerVehicles(
branchId: number,
customerId: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Sales/{branchId}/Customer/{customerId}/Vehicles',
      path: {
        'branchId': branchId,
        'customerId': customerId,
      },
    });
  }

  /**
   * @param branchId 
   * @param customerId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkSalesCustomerUpdatePrivacy(
branchId: number,
customerId: string,
requestBody?: UpdateCustomerPrivacyRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Sales/{branchId}/Customer/{customerId}/UpdatePrivacy',
      path: {
        'branchId': branchId,
        'customerId': customerId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param customerId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkSalesCustomerUpdateCommunication(
branchId: number,
customerId: string,
requestBody?: UpdateCustomerCommunicationRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Sales/{branchId}/Customer/{customerId}/UpdateCommunication',
      path: {
        'branchId': branchId,
        'customerId': customerId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param vehicleId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkVehiclesVehicleUpdateMileage(
branchId: number,
vehicleId: string,
requestBody?: UpdateMileageVehicleRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Vehicles/{branchId}/Vehicle/{vehicleId}/UpdateMileage',
      path: {
        'branchId': branchId,
        'vehicleId': vehicleId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param vehicleId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkVehiclesVehicleUpdateOdometer(
branchId: number,
vehicleId: string,
requestBody?: UpdateOdometerReadingVehicleRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Vehicles/{branchId}/Vehicle/{vehicleId}/UpdateOdometer',
      path: {
        'branchId': branchId,
        'vehicleId': vehicleId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param vehicleId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkVehiclesVehicleUpdateServiceData(
branchId: number,
vehicleId: string,
requestBody?: UpdateServiceDataVehicleRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Vehicles/{branchId}/Vehicle/{vehicleId}/UpdateServiceData',
      path: {
        'branchId': branchId,
        'vehicleId': vehicleId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param vehicleId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkVehiclesVehicleUpdateIdentification(
branchId: number,
vehicleId: string,
requestBody?: UpdateIdentificationVehicleRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Vehicles/{branchId}/Vehicle/{vehicleId}/UpdateIdentification',
      path: {
        'branchId': branchId,
        'vehicleId': vehicleId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param vehicleId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkVehiclesVehicleUpdateInspectionDates(
branchId: number,
vehicleId: string,
requestBody?: UpdateInspectionsVehicleRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Vehicles/{branchId}/Vehicle/{vehicleId}/UpdateInspectionDates',
      path: {
        'branchId': branchId,
        'vehicleId': vehicleId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param vehicleId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkVehiclesVehicleUpdateBaseDetails(
branchId: number,
vehicleId: string,
requestBody?: UpdateVehicleBaseDetailsRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Vehicles/{branchId}/Vehicle/{vehicleId}/UpdateBaseDetails',
      path: {
        'branchId': branchId,
        'vehicleId': vehicleId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param vehicleId 
   * @param regno 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkVehiclesVehicleUpdateVehicle(
branchId: number,
vehicleId: string,
regno: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Vehicles/{branchId}/Vehicle/{vehicleId}/UpdateVehicle/{regno}',
      path: {
        'branchId': branchId,
        'vehicleId': vehicleId,
        'regno': regno,
      },
    });
  }

  /**
   * @param branchId 
   * @param regNo 
   * @param vin 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkVehiclesVehicleFind(
branchId: number,
regNo?: string,
vin?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Vehicles/{branchId}/Vehicle/Find',
      path: {
        'branchId': branchId,
      },
      query: {
        'regNo': regNo,
        'vin': vin,
      },
    });
  }

  /**
   * @param vin 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkServiceHistory(
vin?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/service-history',
      query: {
        'vin': vin,
      },
    });
  }

  /**
   * @param branchId 
   * @param serviceHistoryId 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkServiceHistory1(
branchId: number,
serviceHistoryId: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/service-history/{branchId}/{serviceHistoryId}',
      path: {
        'branchId': branchId,
        'serviceHistoryId': serviceHistoryId,
      },
    });
  }

  /**
   * @param vehicleId 
   * @returns FindSpecificVehicleResponse Success
   * @throws ApiError
   */
  public static getCdkVehiclesVehicleFindSpecific(
vehicleId: string,
): CancelablePromise<FindSpecificVehicleResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Vehicles/{vehicleId}/Vehicle/FindSpecific',
      path: {
        'vehicleId': vehicleId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param branchId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkVehiclesVehicle(
branchId?: number,
requestBody?: CreateVehicleRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Vehicles/Vehicle',
      query: {
        'branchId': branchId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param vehicleId 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkVehiclesVehicleRelations(
vehicleId: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Vehicles/{vehicleId}/Vehicle/Relations',
      path: {
        'vehicleId': vehicleId,
      },
    });
  }

  /**
   * @param vehicleId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkVehiclesVehicleRelations(
vehicleId: string,
requestBody?: CreateVehicleRelationRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Vehicles/{vehicleId}/Vehicle/Relations',
      path: {
        'vehicleId': vehicleId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param vehicleId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putCdkVehiclesVehicleRelations(
vehicleId: string,
requestBody?: CreateVehicleRelationRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/CDK/Vehicles/{vehicleId}/Vehicle/Relations',
      path: {
        'vehicleId': vehicleId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkVehiclesVehicleCreateContract(
branchId: number,
requestBody?: CreateContractRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Vehicles/{branchId}/Vehicle/CreateContract',
      path: {
        'branchId': branchId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param vin 
   * @param sbookingId 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkVehiclesVehicleContracts(
branchId: number,
vin: string,
sbookingId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Vehicles/{branchId}/Vehicle/{vin}/Contracts',
      path: {
        'branchId': branchId,
        'vin': vin,
      },
      query: {
        'sbookingId': sbookingId,
      },
    });
  }

  /**
   * @param branchId 
   * @param vehicleId 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkVehiclesVehicleRelations1(
branchId: number,
vehicleId: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Vehicles/{branchId}/Vehicle/{vehicleId}/Relations',
      path: {
        'branchId': branchId,
        'vehicleId': vehicleId,
      },
    });
  }

  /**
   * @param branchId 
   * @param statuses 
   * @param vehicleTypes 
   * @param vin 
   * @param licensePlate 
   * @param changesSince 
   * @param page 
   * @param pageSize 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkSalesInventoryVehicleSearch(
branchId: number,
statuses?: Array<InventoryVehicleStatus>,
vehicleTypes?: Array<InventoryVehicleType>,
vin?: string,
licensePlate?: string,
changesSince?: string,
page: number = 1,
pageSize: number = 50,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Sales/{branchId}/InventoryVehicle/Search',
      path: {
        'branchId': branchId,
      },
      query: {
        'statuses': statuses,
        'vehicleTypes': vehicleTypes,
        'vin': vin,
        'licensePlate': licensePlate,
        'changesSince': changesSince,
        'page': page,
        'pageSize': pageSize,
      },
    });
  }

  /**
   * @param branchId 
   * @param vehicleId 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkSalesInventoryVehicle(
branchId: number,
vehicleId: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Sales/{branchId}/InventoryVehicle/{vehicleId}',
      path: {
        'branchId': branchId,
        'vehicleId': vehicleId,
      },
    });
  }

  /**
   * @param branchId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkSalesInventoryVehicleCreate(
branchId: number,
requestBody?: CreateInventoryVehicleRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Sales/{branchId}/InventoryVehicle/Create',
      path: {
        'branchId': branchId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param vehicleId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkSalesInventoryVehicleUpdatePrice(
branchId: number,
vehicleId: string,
requestBody?: UpdateInventoryVehiclePricesRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Sales/{branchId}/InventoryVehicle/{vehicleId}/UpdatePrice',
      path: {
        'branchId': branchId,
        'vehicleId': vehicleId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param vehicleId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkSalesInventoryVehicleUpdateDates(
branchId: number,
vehicleId: string,
requestBody?: UpdateInventoryVehicleInventoryDatesRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Sales/{branchId}/InventoryVehicle/{vehicleId}/UpdateDates',
      path: {
        'branchId': branchId,
        'vehicleId': vehicleId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param vehicleId 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkSalesInventoryVehicleTechnicalData(
branchId: number,
vehicleId: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Sales/{branchId}/InventoryVehicle/{vehicleId}/TechnicalData',
      path: {
        'branchId': branchId,
        'vehicleId': vehicleId,
      },
    });
  }

  /**
   * @param branchId 
   * @param salesOrderId 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkSalesSalesOrder(
branchId: number,
salesOrderId: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Sales/{branchId}/SalesOrder/{salesOrderId}',
      path: {
        'branchId': branchId,
        'salesOrderId': salesOrderId,
      },
    });
  }

  /**
   * @param branchId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkSalesSalesOrderCreate(
branchId: number,
requestBody?: CreateSalesOrderRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Sales/{branchId}/SalesOrder/Create',
      path: {
        'branchId': branchId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param salesOrderId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkSalesSalesOrderConfirm(
branchId: number,
salesOrderId: string,
requestBody?: BaseWithMetadataRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Sales/{branchId}/SalesOrder/{salesOrderId}/Confirm',
      path: {
        'branchId': branchId,
        'salesOrderId': salesOrderId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param salesOrderId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkSalesSalesOrderCancel(
branchId: number,
salesOrderId: string,
requestBody?: BaseWithMetadataRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Sales/{branchId}/SalesOrder/{salesOrderId}/Cancel',
      path: {
        'branchId': branchId,
        'salesOrderId': salesOrderId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param freeTextSearch 
   * @param givenName 
   * @param familyName 
   * @param email 
   * @param phone 
   * @param postalCode 
   * @param socialSecurityId 
   * @param page 
   * @param pageSize 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkCustomerCustomersSearch(
branchId: number,
freeTextSearch?: string,
givenName?: string,
familyName?: string,
email?: string,
phone?: string,
postalCode?: string,
socialSecurityId?: string,
page: number = 1,
pageSize: number = 50,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Customer/{branchId}/Customers/Search',
      path: {
        'branchId': branchId,
      },
      query: {
        'freeTextSearch': freeTextSearch,
        'givenName': givenName,
        'familyName': familyName,
        'email': email,
        'phone': phone,
        'postalCode': postalCode,
        'socialSecurityId': socialSecurityId,
        'page': page,
        'pageSize': pageSize,
      },
    });
  }

  /**
   * @param branchId 
   * @param customerId 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkCustomerCustomers(
branchId: number,
customerId: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Customer/{branchId}/Customers/{customerId}',
      path: {
        'branchId': branchId,
        'customerId': customerId,
      },
    });
  }

  /**
   * @param branchId 
   * @param customerId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkCustomerCustomersUpdateDetails(
branchId: number,
customerId: string,
requestBody?: UpdateCustomerDetailsRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Customer/{branchId}/Customers/{customerId}/UpdateDetails',
      path: {
        'branchId': branchId,
        'customerId': customerId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param customerId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkCustomerCustomersUpdateAddress(
branchId: number,
customerId: string,
requestBody?: CustomerAddressesV3,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Customer/{branchId}/Customers/{customerId}/UpdateAddress',
      path: {
        'branchId': branchId,
        'customerId': customerId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param customerId 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkCustomerCustomersVehicles(
branchId: number,
customerId: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Customer/{branchId}/Customers/{customerId}/Vehicles',
      path: {
        'branchId': branchId,
        'customerId': customerId,
      },
    });
  }

  /**
   * @param branchId 
   * @param givenName 
   * @param familyName 
   * @param email 
   * @param phone 
   * @param postalCode 
   * @param socialSecurityId 
   * @param page 
   * @param pageSize 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkServiceCustomerCustomersSearch(
branchId: number,
givenName?: string,
familyName?: string,
email?: string,
phone?: string,
postalCode?: string,
socialSecurityId?: string,
page: number = 1,
pageSize: number = 50,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Service/Customer/{branchId}/Customers/Search',
      path: {
        'branchId': branchId,
      },
      query: {
        'givenName': givenName,
        'familyName': familyName,
        'email': email,
        'phone': phone,
        'postalCode': postalCode,
        'socialSecurityId': socialSecurityId,
        'page': page,
        'pageSize': pageSize,
      },
    });
  }

  /**
   * @param branchId 
   * @param customerId 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkServiceCustomerCustomers(
branchId: number,
customerId: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Service/Customer/{branchId}/Customers/{customerId}',
      path: {
        'branchId': branchId,
        'customerId': customerId,
      },
    });
  }

  /**
   * @param branchId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkServiceCustomerCustomers(
branchId: number,
requestBody?: CreateCustomerRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/Customer/{branchId}/Customers',
      path: {
        'branchId': branchId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param customerId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkServiceCustomerCustomersUpdateNames(
branchId: number,
customerId: string,
requestBody?: UpdateServiceCustomerNameRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/Customer/{branchId}/Customers/{customerId}/UpdateNames',
      path: {
        'branchId': branchId,
        'customerId': customerId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param customerId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkServiceCustomerCustomersUpdateAddress(
branchId: number,
customerId: string,
requestBody?: UpdateServiceCustomerAddressRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/Customer/{branchId}/Customers/{customerId}/UpdateAddress',
      path: {
        'branchId': branchId,
        'customerId': customerId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param freeTextSearch 
   * @param name 
   * @param email 
   * @param phone 
   * @param postalCode 
   * @param taxRegistration 
   * @param reference 
   * @param page 
   * @param pageSize 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkCompanySearch(
branchId: number,
freeTextSearch?: string,
name?: string,
email?: string,
phone?: string,
postalCode?: string,
taxRegistration?: string,
reference?: string,
page: number = 1,
pageSize: number = 50,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Company/{branchId}/Search',
      path: {
        'branchId': branchId,
      },
      query: {
        'freeTextSearch': freeTextSearch,
        'name': name,
        'email': email,
        'phone': phone,
        'postalCode': postalCode,
        'taxRegistration': taxRegistration,
        'reference': reference,
        'page': page,
        'pageSize': pageSize,
      },
    });
  }

  /**
   * @param branchId 
   * @param companyId 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkCompanyFindSpecific(
branchId: number,
companyId: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Company/{branchId}/FindSpecific/{companyId}',
      path: {
        'branchId': branchId,
        'companyId': companyId,
      },
    });
  }

  /**
   * @param branchId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkCompany(
branchId: number,
requestBody?: CreateCompanyRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Company/{branchId}',
      path: {
        'branchId': branchId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param companyId 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkCompanyVehicles(
branchId: number,
companyId: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Company/{branchId}/Vehicles/{companyId}',
      path: {
        'branchId': branchId,
        'companyId': companyId,
      },
    });
  }

  /**
   * @param branchId 
   * @param companyId 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkCompanyRelations(
branchId: number,
companyId: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Company/{branchId}/Relations/{companyId}',
      path: {
        'branchId': branchId,
        'companyId': companyId,
      },
    });
  }

  /**
   * @param branchId 
   * @param companyId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkCompanyDetails(
branchId: number,
companyId: string,
requestBody?: CreateCompanyRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Company/{branchId}/Details/{companyId}',
      path: {
        'branchId': branchId,
        'companyId': companyId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param companyId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkCompanyAddress(
branchId: number,
companyId: string,
requestBody?: CompanyAddress,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Company/{branchId}/Address/{companyId}',
      path: {
        'branchId': branchId,
        'companyId': companyId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param customerId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkServiceCustomerRelation(
branchId: number,
customerId: string,
requestBody?: CreateCustomerCompanyRelation,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/Customer/{branchId}/Relation/{customerId}',
      path: {
        'branchId': branchId,
        'customerId': customerId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param customerId 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkServiceCustomerRelation(
branchId: number,
customerId: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Service/Customer/{branchId}/Relation/{customerId}',
      path: {
        'branchId': branchId,
        'customerId': customerId,
      },
    });
  }

  /**
   * @param branchId 
   * @param requestBody 
   * @returns RepairOrder Success
   * @throws ApiError
   */
  public static postCdkServiceAddRepairOrder(
branchId: number,
requestBody?: reateRepairOrderRequest,
): CancelablePromise<RepairOrder> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/AddRepairOrder/{branchId}',
      path: {
        'branchId': branchId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param contactName 
   * @param licensePlate 
   * @param phone 
   * @param status 
   * @param dueInDateFrom 
   * @param dueInDateTo 
   * @param reference 
   * @param page 
   * @param pageSize 
   * @returns FindRepairOrdersResponse Success
   * @throws ApiError
   */
  public static getCdkServiceRepairOrderFindRepairOrder(
branchId: number,
contactName?: string,
licensePlate?: string,
phone?: string,
status?: string,
dueInDateFrom?: string,
dueInDateTo?: string,
reference?: string,
page?: number,
pageSize?: number,
): CancelablePromise<FindRepairOrdersResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Service/RepairOrder/FindRepairOrder/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'ContactName': contactName,
        'LicensePlate': licensePlate,
        'Phone': phone,
        'Status': status,
        'DueInDateFrom': dueInDateFrom,
        'DueInDateTo': dueInDateTo,
        'Reference': reference,
        'Page': page,
        'PageSize': pageSize,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param repairOrderId 
   * @returns RepairOrder Success
   * @throws ApiError
   */
  public static getCdkServiceRepairOrderGetRepairOrder(
branchId: number,
repairOrderId?: string,
): CancelablePromise<RepairOrder> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Service/RepairOrder/GetRepairOrder/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'repairOrderId': repairOrderId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param repairOrderId 
   * @param requestBody 
   * @returns CreateJobResponse Success
   * @throws ApiError
   */
  public static postCdkServiceRepairOrderCreateRepairOrderJob(
branchId: number,
repairOrderId?: string,
requestBody?: Job,
): CancelablePromise<CreateJobResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/RepairOrder/CreateRepairOrderJob/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'repairOrderId': repairOrderId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param repairOrderId 
   * @param requestBody 
   * @returns MultiplyRepairOrderJobsResponse Success
   * @throws ApiError
   */
  public static postCdkServiceRepairOrderCreateMultipleRepairOrderJobs(
branchId: number,
repairOrderId?: string,
requestBody?: CreateMultiplyRepairOrderJobs,
): CancelablePromise<MultiplyRepairOrderJobsResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/RepairOrder/CreateMultipleRepairOrderJobs/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'repairOrderId': repairOrderId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param repairOrderId 
   * @param jobId 
   * @returns RepairOrderJob Success
   * @throws ApiError
   */
  public static getCdkServiceRepairOrderGetRepairOrderJob(
branchId: number,
repairOrderId?: string,
jobId?: string,
): CancelablePromise<RepairOrderJob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Service/RepairOrder/GetRepairOrderJob/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'repairOrderId': repairOrderId,
        'jobId': jobId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param repairOrderId 
   * @param jobId 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteCdkServiceRepairOrderDeleteRepairOrderJob(
branchId: number,
repairOrderId?: string,
jobId?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/CDK/Service/RepairOrder/DeleteRepairOrderJob/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'repairOrderId': repairOrderId,
        'jobId': jobId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param repairOrderId 
   * @param jobId 
   * @param requestBody 
   * @returns LaborResponse Success
   * @throws ApiError
   */
  public static postCdkServiceRepairOrderAddLaborOrderJob(
branchId: number,
repairOrderId?: string,
jobId?: string,
requestBody?: LaborRequest,
): CancelablePromise<LaborResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/RepairOrder/AddLaborOrderJob/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'repairOrderId': repairOrderId,
        'jobId': jobId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param repairOrderId 
   * @param jobId 
   * @param requestBody 
   * @returns PartResponse Success
   * @throws ApiError
   */
  public static postCdkServiceRepairOrderAddPartOrderJob(
branchId: number,
repairOrderId?: string,
jobId?: string,
requestBody?: RepairOrderPartRequest,
): CancelablePromise<PartResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/RepairOrder/AddPartOrderJob/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'repairOrderId': repairOrderId,
        'jobId': jobId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param repairOrderId 
   * @param jobId 
   * @param requestBody 
   * @returns NoteResponse Success
   * @throws ApiError
   */
  public static postCdkServiceRepairOrderAddNotesOrderJob(
branchId: number,
repairOrderId?: string,
jobId?: string,
requestBody?: NoteRequest,
): CancelablePromise<NoteResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/RepairOrder/AddNotesOrderJob/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'repairOrderId': repairOrderId,
        'jobId': jobId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param repairOrderId 
   * @param jobId 
   * @param requestBody 
   * @returns FeeResponse Success
   * @throws ApiError
   */
  public static postCdkServiceRepairOrderAddFeeOrderJob(
branchId: number,
repairOrderId?: string,
jobId?: string,
requestBody?: FeeRequest,
): CancelablePromise<FeeResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/RepairOrder/AddFeeOrderJob/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'repairOrderId': repairOrderId,
        'jobId': jobId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param repairOrderId 
   * @param jobId 
   * @param requestBody 
   * @returns MenuResponse Success
   * @throws ApiError
   */
  public static postCdkServiceRepairOrderAddMenuOrderJob(
branchId: number,
repairOrderId?: string,
jobId?: string,
requestBody?: MenuRequest,
): CancelablePromise<MenuResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/RepairOrder/AddMenuOrderJob/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'repairOrderId': repairOrderId,
        'jobId': jobId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param repairOrderId 
   * @param jobId 
   * @param requestBody 
   * @returns ItemResponse Success
   * @throws ApiError
   */
  public static postCdkServiceRepairOrderAddItemOrderJob(
branchId: number,
repairOrderId?: string,
jobId?: string,
requestBody?: ItemRequest,
): CancelablePromise<ItemResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/RepairOrder/AddItemOrderJob/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'repairOrderId': repairOrderId,
        'jobId': jobId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param repairOrderId 
   * @param requestBody 
   * @returns ItemResponse Success
   * @throws ApiError
   */
  public static postCdkServiceRepairOrderUpdateItemOrderJob(
branchId: number,
repairOrderId?: string,
requestBody?: ItemUpdateRequest,
): CancelablePromise<ItemResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/RepairOrder/UpdateItemOrderJob/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'repairOrderId': repairOrderId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param repairOrderId 
   * @param itemIds 
   * @returns string Success
   * @throws ApiError
   */
  public static deleteCdkServiceRepairOrderDeleteRepairOrderItemsAsync(
branchId: number,
repairOrderId?: string,
itemIds?: Array<string>,
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/CDK/Service/RepairOrder/DeleteRepairOrderItemsAsync/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'repairOrderId': repairOrderId,
        'itemIds': itemIds,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param repairOrderId 
   * @param jobId 
   * @param itemId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkServiceRepairOrderSetRepairOrderItemDiscount(
branchId: number,
repairOrderId?: string,
jobId?: string,
itemId?: string,
requestBody?: Discount,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/RepairOrder/SetRepairOrderItemDiscount/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'repairOrderId': repairOrderId,
        'jobId': jobId,
        'itemId': itemId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param repairOrderId 
   * @param requestBody 
   * @returns RepairOrder Success
   * @throws ApiError
   */
  public static postCdkServiceRepairOrderCheckInCustomer(
branchId: number,
repairOrderId?: string,
requestBody?: CheckInCustomerRequest,
): CancelablePromise<RepairOrder> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/RepairOrder/CheckInCustomer/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'repairOrderId': repairOrderId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param repairOrderId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static patchCdkServiceRepairOrderUpdateRepairOrderDetails(
branchId: number,
repairOrderId?: string,
requestBody?: UpdateRepairOrderDetailsRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/CDK/Service/RepairOrder/UpdateRepairOrderDetails/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'repairOrderId': repairOrderId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param repairOrderId 
   * @param requestBody 
   * @returns BaseErrorResponse Success
   * @throws ApiError
   */
  public static postCdkServiceRepairOrderUpdateRepairOrderAppointmentDetails(
branchId: number,
repairOrderId: string,
requestBody?: AppointmentRequest,
): CancelablePromise<BaseErrorResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/RepairOrder/{repairOrderId}/UpdateRepairOrderAppointmentDetails/{branchId}',
      path: {
        'branchId': branchId,
        'repairOrderId': repairOrderId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param repairOrderId 
   * @param requestBody 
   * @returns BaseErrorResponse Success
   * @throws ApiError
   */
  public static postCdkServiceRepairOrderUpdateRepairOrderPlanningDetails(
branchId: number,
repairOrderId: string,
requestBody?: PlanningRequest,
): CancelablePromise<BaseErrorResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/RepairOrder/{repairOrderId}/UpdateRepairOrderPlanningDetails/{branchId}',
      path: {
        'branchId': branchId,
        'repairOrderId': repairOrderId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param repairOrderId 
   * @param requestBody 
   * @returns RepairOrder Success
   * @throws ApiError
   */
  public static postCdkServiceRepairOrderCheckOutVehicle(
branchId: number,
repairOrderId?: string,
requestBody?: CheckOutDetailsRequest,
): CancelablePromise<RepairOrder> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/RepairOrder/CheckOutVehicle/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'repairOrderId': repairOrderId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @returns GetServiceAdvisorsResponse Success
   * @throws ApiError
   */
  public static getCdkServiceAdvisors(
branchId: number,
): CancelablePromise<GetServiceAdvisorsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Service/Advisors/{branchId}',
      path: {
        'branchId': branchId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param branchId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkServicePartsOrderCreatePartsOrder(
branchId: number,
requestBody?: CreatePartsOrderRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/PartsOrder/CreatePartsOrder/{branchId}',
      path: {
        'branchId': branchId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param branchId 
   * @param partsOrderId 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkServicePartsOrderGetPartsOrder(
branchId: number,
partsOrderId?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Service/PartsOrder/GetPartsOrder/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'partsOrderId': partsOrderId,
      },
    });
  }

  /**
   * @param branchId 
   * @param brandCode 
   * @param partCode 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkServicePartsOrderGetParts(
branchId: number,
brandCode?: string,
partCode?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Service/PartsOrder/GetParts/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'brandCode': brandCode,
        'partCode': partCode,
      },
    });
  }

  /**
   * @param branchId 
   * @param partId 
   * @returns any Success
   * @throws ApiError
   */
  public static getCdkServicePartsOrderGetPartAvailability(
branchId: number,
partId?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/CDK/Service/PartsOrder/GetPartAvailability/{branchId}',
      path: {
        'branchId': branchId,
      },
      query: {
        'partId': partId,
      },
    });
  }

  /**
   * @param branchId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postCdkServiceVehicleActions(
branchId: number,
requestBody?: CreateVehicleActionsRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CDK/Service/VehicleActions/{branchId}',
      path: {
        'branchId': branchId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

}
